module.exports = __webpack_public_path__ + "img/ltkbaby-3x.713f83a.jpg";